import React, { useState, useEffect, useRef } from 'react';
import IconPlus from '../icon/IconPlus';
import IconMinus from '../icon/IconMinus';
import './questionanswer.scss';

const CustomAnswer = ({
  label,
  text,
  line,
  id,
  name,
  title,
  li1,
  li2,
  li3,
  li4,
  li5,
}) => {
  const [show, setShow] = useState(false);
  const [height, setHeight] = useState(0);
  const divRef = useRef(null);

  const handleClick = (e) => {
    setShow((prev) => !prev);
  };

  useEffect(() => {
    const handleWindowResize = () => {
      if (divRef.current) setHeight(divRef.current.offsetHeight);
    };

    handleWindowResize();
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  useEffect(() => {
    const handleWindowClick = (e) => {
      if (!e.target.closest('#SelectAccordion-' + id)) {
        setShow(false);
      }
    };

    window.addEventListener('click', handleWindowClick);
    return () => window.removeEventListener('click', handleWindowClick);
  }, [id]);

  return (
    <div
      onClick={(e) => handleClick(e)}
      className="accordion"
      id={'SelectAccordion-' + id}
      name={name}
    >
      <div className="accordion-header">
        <div className={show ? 'accordionActive' : ''}>{label}</div>
        {/* <p>{show ? title : ''}</p> */}
        <div>{show ? <IconMinus /> : <IconPlus />}</div>
      </div>
      <div
        className="accordion-parent"
        style={{
          height: `${show ? height : 0}px`,
          overflow: 'hidden',
          transition: 'all 400ms',
        }}
      >
        <div className="accordion-body" ref={divRef}>
          {text}
          <div>{li1}</div>
          <div>{li2}</div>
          <div>{li3}</div>
          <div>{li4}</div>
          <div>{li5}</div>
        </div>
      </div>
      <div className={`${line}`}></div>
    </div>
  );
};

export default CustomAnswer;
